import { render, staticRenderFns } from "./AllApprovalsLogsTable.vue?vue&type=template&id=4f1975e8&"
import script from "./AllApprovalsLogsTable.vue?vue&type=script&lang=js&"
export * from "./AllApprovalsLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./AllApprovalsLogsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports